import { Liquid } from 'liquidjs';
const liquid = new Liquid();
const getPathValue = (obj, paths) => {
    if (typeof obj === 'undefined' || paths.length === 0) {
        return obj;
    }
    return getPathValue(obj[paths[0]], paths.slice(1));
};
const compileValue = (value, params) => {
    if (value === null)
        return value;
    switch (typeof value) {
        case 'object':
            if (Array.isArray(value)) {
                return value.map(v => compileValue(v, params));
            }
            return Object.keys(value).reduce((preValue, key) => (Object.assign(Object.assign({}, preValue), { [key]: compileValue(value[key], params) })), {});
        case 'string':
            if (value.startsWith('$')) {
                return getPathValue(params, value.slice(1).split('.'));
            }
            if (value.indexOf('{{') > -1) {
                try {
                    return liquid.parseAndRenderSync(value, params);
                }
                catch (_a) {
                    return value;
                }
            }
            return value;
        default:
            return value;
    }
};
export const compileProps = (props, context) => {
    if (typeof props === 'string') {
        return props;
    }
    const compiledProps = {};
    Object.keys(props).forEach(key => {
        compiledProps[key] = compileValue(props[key], context);
    });
    return compiledProps;
};
//# sourceMappingURL=props-compiler.utils.js.map